import io from 'socket.io-client'
import Vue from 'vue'

// import store from '@/store'
import router from '@/router'

// eslint-disable-next-line
let toastDisconnect: any

//Connection
const socket = io({
  transports: ['websocket'],
  // autoConnect: false,
  // reconnection: true,
  // transportOptions: {
  //   polling: {
  //     extraHeaders: {
  //       'X-XSRF-Token': getCSRF(),
  //     },
  //   },
  // },
})

socket.on('connect', () => {
  if (toastDisconnect) {
    toastDisconnect.close()
    // eslint-disable-next-line
    ;(Vue as any).$toast.info('Link to the application server return')
  }
  // store.dispatch('tag/subscribe')
  if (
    router.currentRoute.path == '/500' &&
    typeof router.currentRoute.query.r == 'string'
  ) {
    router.replace(router.currentRoute.query.r)
  }
})

socket.on('disconnect', () => {
  // eslint-disable-next-line
  toastDisconnect = (Vue as any).$toast.error(
    'Link to the application server is broken',
    {
      duration: 86400000,
    }
  )
})

// eslint-disable-next-line
socket.on('error', (err: any) => {
  // console.log(err)
})

socket.on('close', () => {
  // eslint-disable-next-line
  ;(Vue as any).$toast.error('server:: connection lost!')
})

export default socket
